/**
 * Retry window input -> stored `retryLimitDuration`.
 *
 * The backend/bt-common (`overdueWindowMs`, `getUpperLimit`) treat a falsy duration as "not set" and
 * fall back to the 30-minute default, so 0 never meant "unlimited". Anything below 1 (blank, 0,
 * negative, NaN) is stored as 0 (not undefined: an edit PATCH drops undefined keys, so the server
 * would keep the old window), fractions are floored.
 */
export const normalizeRetryDuration = (raw: string): number => {
    const n = Number.parseInt(raw, 10);
    return Number.isFinite(n) && n >= 1 ? n : 0;
};

/**
 * The window the backend will actually apply. `overdueWindowMs` needs BOTH duration and unit; with
 * either missing/0 it uses the 30-minute default, so the label must not pair a default number with
 * a leftover unit (e.g. "30 hours").
 */
export const effectiveRetryWindow = (
    duration: number | undefined,
    unit: 'minutes' | 'hours' | undefined,
    defaultMinutes: number,
): { value: number; unit: 'minutes' | 'hours' } =>
    duration && unit ? { value: duration, unit } : { value: defaultMinutes, unit: 'minutes' };
